// login-concessionarias.component.ts
import {Component, OnInit} from '@angular/core';

import {FormsModule} from '@angular/forms';

import {EmailSendTokenComponent} from './email-send-token/email-send-token.component';

import {ButtonModule} from 'primeng/button';
import {CardModule} from 'primeng/card';
import {DialogModule} from 'primeng/dialog';
import {TokenEmailComponent} from "./token-email/token-email.component";

@Component({
    selector: 'app-login-concessionarias',
    standalone: true,
  imports: [
    FormsModule,
    ButtonModule,
    CardModule,
    DialogModule,
    EmailSendTokenComponent,
    TokenEmailComponent
],
    templateUrl: './login-concessionarias.component.html',
    styleUrl: './login-concessionarias.component.css'
})
export class LoginConcessionariasComponent implements OnInit {
    emailSent: boolean = false;
    email: string = '';

    constructor() {
    }

    ngOnInit(): void {
        const storedEmail = sessionStorage.getItem('concessionariasEmail');
        const storedEmailSent = sessionStorage.getItem('concessionariasEmailSent');

        if (storedEmail) {
            this.email = storedEmail;
        }
        if (storedEmailSent === 'true') {
            this.emailSent = true;
        }
    }

    onEmailSubmitted(submittedEmail: string) {
        this.email = submittedEmail;
        this.emailSent = true;

    }

}